import React, { useLayoutEffect } from 'react';
import {
  PageContainer,
  ContentContainer,
  Content,
  Title,
  Text,
  StyledList,
  StyledLi,
  DateSubtitle,
} from './Hikes.styles';

export const Dymin2026: React.FC = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>Pojezierze Pomorskie - Dymin</Title>
          <DateSubtitle>24-26.07.2026 | 14 miejsc</DateSubtitle>
          <Text>
            Relaksujący weekend nad jeziorem Dymno. Połączenie aktywności na świeżym powietrzu z
            warsztatami zielarskimi i czasem na regenerację w otoczeniu przyrody.
          </Text>

          <Text style={{ marginBottom: '5px' }}>
            <strong>W cenie:</strong>
          </Text>
          <StyledList>
            <StyledLi>2 noclegi nad jeziorem Dymno</StyledLi>
            <StyledLi>śniadania i obiadokolacje</StyledLi>
            <StyledLi>spływ kajakowy</StyledLi>
            <StyledLi>ognisko</StyledLi>
            <StyledLi>warsztaty z zielarstwa</StyledLi>
            <StyledLi>transport z Trójmiasta</StyledLi>
            <StyledLi>ubezpieczenie</StyledLi>
            <StyledLi>opieka i organizacja</StyledLi>
          </StyledList>
          <Text style={{ marginBottom: '5px' }}>
            <strong>We własnym zakresie:</strong>
          </Text>
          <StyledList>
            <StyledLi>atrakcje dodatkowe (rowerki wodne, sauna)</StyledLi>
          </StyledList>

          <Text style={{ marginBottom: '5px' }}>
            <strong>Harmonogram:</strong>
          </Text>
          <StyledList>
            <StyledLi>
              24.07 - wyjazd busem z Trójmiasta, trekking po okolicznych lasach, wieczorny chill
            </StyledLi>
            <StyledLi>
              25.07 - śniadanie z widokiem na jezioro Dymno, spływ kajakowy rzeką Brdą, ognisko
            </StyledLi>
            <StyledLi>26.07 - czas wolny, warsztaty zielarskie, powrót do Trójmiasta</StyledLi>
          </StyledList>
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};

export default Dymin2026;
